const e = {
  xs: { items: 1, peek: 15 },
  sm: { items: 2, peek: 20 },
  md: { items: 3, peek: 25 },
  lg: { items: 4, peek: 15 },
  xl: { items: 5, peek: 10 }
}, s = [
  { size: 1280, key: "xl" },
  { size: 1024, key: "lg" },
  { size: 768, key: "md" },
  { size: 640, key: "sm" }
];
export {
  s as breakpoints,
  e as defaultBreakpoints
};
